
import React from 'react'

import { SupportingDocumentationQuestionnaire } from '../../../../../../../lib/Questionnaires'
import {
  YesNoRadioOptions,
  bindTargetMixin,
  CancelButton,
  escapeCancel,
  QuestionRadioButtonInput,
  SaveButton
} from '../../../../../../shared/FormBuilder'
import { Paper } from '../../../../../../shared/NarusMaterial'

import { style } from './style'

class AdvancedDirective extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.state = {
      value: { ...props.value }
    }
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
  }

  getValues () {
    return { ...this.state.value }
  }

  handleFormSubmit () {
    const { handleSubmit } = this.props
    handleSubmit(this.getValues())
    this.setState({
      isSubmitting: true
    })
  }

  handleKeyDown (e) {
    escapeCancel(e, this.props.cancel)
  }

  render () {
    const documentation =
      this.state.value.ADHave === 'yes' && !this.state.value.ADNarusCopy
    const disableSave = !this.state.value.ADHave || documentation

    return (
      <button
        style={{ all: 'unset' }}
        onKeyDown={this.handleKeyDown}
        className='margin-top margin-bottom col-xs-12'
      >
        <Paper>
          <h2 className='col-xs-12'> Advanced Directive </h2>

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.ADHave}
            required
          />

          <div
            className='col-xs-12 margin-top'
            style={style.subHead}
          >
            {' '}
            If, yes?
            {' '}
          </div>

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.ADNarusCopy}
            required={this.state.value.ADHave === 'yes'}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.ADChanges}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.ADCopies}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.ADQuestions}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.ADSendCopies}
          />

          <div
            className='col-xs-12 margin-top'
            style={style.subHead}
          >
            {' '}
            If, no?
            {' '}
          </div>

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.ADLearning}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.ADComplete}
          />

          <div
            className='row margin-top end-xs'
            style={style.marg}
          >
            <div className='col-xs-offset-8 col-xs-4'>
              <CancelButton onClick={this.props.cancel} />
              <SaveButton
                disabled={disableSave || this.state.isSubmitting}
                onClick={this.handleFormSubmit}
              />
            </div>
          </div>
        </Paper>
      </button>
    )
  }
}

export default AdvancedDirective
